import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { capitalize, IntlCurrencyFormat } from 'utils/helpers';
import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { OrderListingType } from 'types/order';

export type FiltersType = 'all' | 'closed' | 'canceled' | 'hold' | 'open';
export type ViewType = 'orders-map' | 'table';

export type CurrentData = {
  page: number;
  pages: number;
};

export const filters = (t: TFunction): { id: string; value: FiltersType; label: string }[] => [
  {
    id: 'all',
    value: 'all',
    label: t('orders:all-orders'),
  },
  {
    id: 'open',
    value: 'open',
    label: t('orders:open'),
  },
  {
    id: "hold",
    value: "hold",
    label: t("orders:hold")
  },
  {
    id: "closed",
    value: "closed",
    label: t("orders:closed")
  },
  {
    id: "canceled",
    value: "canceled",
    label: t("orders:cancelled")
  }
];

export const viewsFilters = (t: TFunction): { id: string; value: ViewType; label: string, icon: IconProp}[] => [
  {
    id: 'orders-map',
    value: 'orders-map',
    label: t('orders:map'),
    icon: "map"
  },
  {
    id: 'table',
    value: "table",
    label: t('orders:table'),
    icon: "table"
  }
];

export const reducerModals = (_, action) => {
  switch (action.type) {
    case 'new-order':
      return { mode: 'new-order', };
    default:
      return {
        mode: null,
        data: null
	  };
  }
};

export const intialReducerState = {
  mode: null,
  data: null
};

const columnHelper = createColumnHelper<OrderListingType>();

type GetColumnListParams = {
  t: TFunction,
  hidecolumns: {
    agency: boolean,
    status: boolean
  }
}

export const getColumnList = ({ t, hidecolumns }: GetColumnListParams) => {
  let list = [
    columnHelper.accessor("order_id", {
      header: t('orders:order-id').toString(),
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("agency", {
      header: t('common:agency'),
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("address", {
      header: t('orders:address'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("opener", {
      header: t('orders:openedBy'),
      cell: (info) => info.getValue()
    }),
    columnHelper.accessor("seller", {
      header: t('common:seller'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("buyer", {
      header: t('common:buyer'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("transaction_type", {
      header: t('orders:transaction-type'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("type", {
      header: t('orders:type'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("closing_date", {
      header: t('orders:closing-date'),
      cell: (info) => info.getValue() || t('common:pending'),
    }),
    columnHelper.accessor("status", {
      header: t('orders:status'),
      cell: (info) => capitalize(info.getValue()) || t('common:pending')
    }),
    columnHelper.accessor("purchase_price", {
      header: t('orders:purchase-price'),
      cell: (info) => (info.getValue() ? IntlCurrencyFormat(info.getValue() as number) : t('common:pending'))
    }),
    columnHelper.accessor("loan_amount", {
      header: t('orders:load-amount'),
      cell: (info) => (info.getValue() ? IntlCurrencyFormat(info.getValue() as number) : t('common:pending')),
    }),
  ];

  if (hidecolumns.agency) {
    list = list.filter(column => column.accessorKey !== "agency");
  }

  if (hidecolumns.status) {
    list = list.filter(column => column.accessorKey !== "status");
  }

  return list;
};

export default { };
